export type EquityMethodChangeModalContext = {
  currentMethod: string;
  filingId: string;
  orgId: string;
  onSuccess: () => void; // Redirect to filings page
};

let currentContext: EquityMethodChangeModalContext | null = null;

export const EQUITY_METHOD_CHANGE_MODAL_OPEN_EVENT = 'equityMethodChangeModal:open';
export const EQUITY_METHOD_CHANGE_MODAL_CLOSE_EVENT = 'equityMethodChangeModal:close';

export function setEquityMethodChangeModalContext(ctx: EquityMethodChangeModalContext) {
  currentContext = ctx;
}

export function getEquityMethodChangeModalContext() {
  return currentContext;
}

export function openEquityMethodChangeModal() {
  document.dispatchEvent(new CustomEvent(EQUITY_METHOD_CHANGE_MODAL_OPEN_EVENT));
}

export function closeEquityMethodChangeModal() {
  document.dispatchEvent(new CustomEvent(EQUITY_METHOD_CHANGE_MODAL_CLOSE_EVENT));
}

